import { PenNameStoryList } from './PenNameStoryList'
import { withPenNameStoryList } from './withPenNameStoryList'

const ConnectedPenNameStoryList = withPenNameStoryList(PenNameStoryList)

export { ConnectedPenNameStoryList as PenNameStoryList }
